/**
 * Created by handd on 2021/9/24.
 * 消息管理
 */
import React from "react";
import {message} from "antd";
import axios from "axios";

const MESSAGE_MANAGEMENT_TOGGLE_LOADING = "messageManagement/MESSAGE_MANAGEMENT_TOGGLE_LOADING";//加载标志
const MESSAGE_MANAGEMENT_TOGGLE_BUTTON_LOADING = "messageManagement/MESSAGE_MANAGEMENT_TOGGLE_BUTTON_LOADING";//提交加载标志
const MESSAGE_MANAGEMENT_UPDATE_DATA = "messageManagement/MESSAGE_MANAGEMENT_UPDATE_DATA";//更新状态
const MESSAGE_MANAGEMENT_STORE_MESSAGES = "messageManagement/MESSAGE_MANAGEMENT_STORE_MESSAGES";
const MESSAGE_MANAGEMENT_STORE_MESSAGE_CATEGORIES = "messageManagement/MESSAGE_MANAGEMENT_STORE_MESSAGE_CATEGORIES";
const MESSAGE_MANAGEMENT_STORE_MESSAGE_TYPES = "messageManagement/MESSAGE_MANAGEMENT_STORE_MESSAGE_TYPES";
const MESSAGE_MANAGEMENT_STORE_MESSAGE_GROUPS = "messageManagement/MESSAGE_MANAGEMENT_STORE_MESSAGE_GROUPS";
const MESSAGE_MANAGEMENT_STORE_MESSAGE_MEMBERS = "messageManagement/MESSAGE_MANAGEMENT_STORE_MESSAGE_MEMBERS";
const MESSAGE_MANAGEMENT_ADD_MESSAGE = "messageManagement/MESSAGE_MANAGEMENT_ADD_MESSAGE";
const MESSAGE_MANAGEMENT_EDIT_MESSAGE = "messageManagement/MESSAGE_MANAGEMENT_EDIT_MESSAGE";
const MESSAGE_MANAGEMENT_VIEW_MESSAGE = "messageManagement/MESSAGE_MANAGEMENT_VIEW_MESSAGE";

// reducer
export const messageSent = (state = {
  loading: false,
  buttonLoading: false,
  addVisible: false,
  editVisible: false,
  viewVisible: false,

  messages: [],
  message: {},
  messageCategories: [],
  messageTypes: [],
  messageType: {},
  messageMembers: [],
  messageGroups: [],

}, action) => {
  switch (action.type) {
    case MESSAGE_MANAGEMENT_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    case MESSAGE_MANAGEMENT_TOGGLE_BUTTON_LOADING:
      return {
        ...state,
        buttonLoading: action.data
      };
    case MESSAGE_MANAGEMENT_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case MESSAGE_MANAGEMENT_STORE_MESSAGES:
      return {
        ...state,
        messages: action.data,
        message: {},
        buttonLoading: false,
      };
    case MESSAGE_MANAGEMENT_STORE_MESSAGE_CATEGORIES:
      return {
        ...state,
        messageCategories: action.data,
      };
    case MESSAGE_MANAGEMENT_STORE_MESSAGE_TYPES:
      return {
        ...state,
        messageTypes: action.data,
      };
    case MESSAGE_MANAGEMENT_STORE_MESSAGE_GROUPS:
      return {
        ...state,
        messageGroups: action.data,
      };
    case MESSAGE_MANAGEMENT_STORE_MESSAGE_MEMBERS:
      return {
        ...state,
        messageMembers: action.data,
      };
    case MESSAGE_MANAGEMENT_ADD_MESSAGE:
      return {
        ...state,
        addVisible: true
      };
    case MESSAGE_MANAGEMENT_EDIT_MESSAGE:
      return {
        ...state,
        message: action.data,
        editVisible: true,
      };
    case MESSAGE_MANAGEMENT_VIEW_MESSAGE:
      return {
        ...state,
        message: action.data,
        viewVisible: true,
      };
    default:
      return state
  }
};

/**
 * 加载标志变更
 */
export const toggleLoading = (show) => {
  return {
    type: MESSAGE_MANAGEMENT_TOGGLE_LOADING,
    data: show
  }
};

/**
 * 按钮加载标志变更
 */
export const toggleButtonLoading = (show) => {
  return {
    type: MESSAGE_MANAGEMENT_TOGGLE_BUTTON_LOADING,
    data: show
  }
};

/**
 * update data based
 */
export const updateData = (data) => {
  return {
    type: MESSAGE_MANAGEMENT_UPDATE_DATA,
    data: data
  }
};

/**
 * query all messages
 */
export const queryMessages = (data) => (dispatch) => {
  message.loading({content: "查询中……", key: "query"});
  axios({
    method: "POST",
    url: "/api-message/message/query",
    contentType: "application/json",
    withCredentials: true,
    data: data,
  }).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          message.success({content: "查询成功", key: "query", duration: 1});
          dispatch(storeMessages(response.data));
        } else {
          message.warning({content: "未查询到消息", key: "query", duration: 3});
        }
      }
    }
  ).catch(err => {
    message.error({content: "获取消息失败", key: "query", duration: 3});
  });
};

/**
 * store all messages
 */
export const storeMessages = (messages) => {
  return {
    type: MESSAGE_MANAGEMENT_STORE_MESSAGES,
    data: messages
  }
};

/**
 * get all message categories
 */
export const getMessageCategories = () => (dispatch) => {
  axios.get("/api-message/messageCategories", {contentType: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storeMessageCategories(response.data));
        } else {
          message.warning("未获取到消息类别", 3);
        }
      }
    }
  ).catch(err => {
    message.error("获取消息类别失败", 3);
  });
};

/**
 * store all message categories
 */
export const storeMessageCategories = (messageCategories) => {
  return {
    type: MESSAGE_MANAGEMENT_STORE_MESSAGE_CATEGORIES,
    data: messageCategories
  }
};

/**
 * get all message types
 */
export const getMessageTypes = (data) => (dispatch) => {
  if(data == null) {
    axios.get("/api-message/messageTypes", {contentType: "application/json"}).then(
      response => {
        if (response.status === 200) {
          if (response.data) {
            dispatch(storeMessageTypes(response.data));
          } else {
            message.warning("未获取到消息类型", 3);
          }
        }
      }
    ).catch(err => {
      message.error("获取消息类型失败", 3);
    });
  }
  else
    axios.get(`/api-message/messageTypes?category=${data}`, {contentType: "application/json"}).then(
      response => {
        if (response.status === 200) {
          if (response.data) {
            dispatch(storeMessageTypes(response.data));
          } else {
            message.warning("未获取到消息类型", 3);
          }
        }
      }
    ).catch(err => {
      message.error("获取消息类型失败", 3);
    });
};

/**
 * store all message types
 */
export const storeMessageTypes = (messageTypes) => {
  return {
    type: MESSAGE_MANAGEMENT_STORE_MESSAGE_TYPES,
    data: messageTypes
  }
};

/**
 * get all message groups
 */
export const getMessageGroups = () => (dispatch) => {
  axios.get("/api-message/messageGroups", {contentType: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storeMessageGroups(response.data));
        } else {
          message.warning("未获取到消息组", 3);
        }
      }
    }
  ).catch(err => {
    message.error("获取消息组失败", 3);
  });
};

/**
 * store all message groups
 */
export const storeMessageGroups = (messageGroups) => {
  return {
    type: MESSAGE_MANAGEMENT_STORE_MESSAGE_GROUPS,
    data: messageGroups
  }
};

/**
 * get all message members
 */
export const getMessageMembers = () => (dispatch) => {
  axios.get("/api-message/messageMembers", {contentType: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storeMessageMembers(response.data));
        } else {
          message.warning("未获取到消息类型", 3);
        }
      }
    }
  ).catch(err => {
    message.error("获取消息类型失败", 3);
  });
};

/**
 * store all message members
 */
export const storeMessageMembers = (messageMembers) => {
  return {
    type: MESSAGE_MANAGEMENT_STORE_MESSAGE_MEMBERS,
    data: messageMembers
  }
};
// /**
//  * get work groups by department
//  */
// export const getWorkGroups = (department) => (dispatch) => {
//     axios.get(`/user-service/workGroups/${department}`, {contentType: "application/json"}).then(
//         response => {
//             if (response.status === 200) {
//                 if (response.data) {
//                     dispatch(storeWorkGroups(response.data));
//                 } else {
//                     message.warning("未获取到班组", 3);
//                 }
//             }
//         }
//     ).catch(err => {
//         message.error("获取班组失败", 3);
//     });
// };
//
// /**
//  * store work groups
//  */
// export const storeWorkGroups = (workGroups) => {
//     return {
//         type: MESSAGE_MANAGEMENT_STORE_WORK_GROUPS,
//         data: workGroups
//     }
// };
//
// /**
//  * get work shifts by work group
//  */
// export const getWorkShifts = (workgroup) => (dispatch) => {
//     axios.get(`/user-service/workShifts/${workgroup}`, {contentType: "application/json"}).then(
//         response => {
//             if (response.status === 200) {
//                 if (response.data) {
//                     dispatch(storeWorkShifts(response.data));
//                 } else {
//                     message.warning("未获取到班次", 3);
//                 }
//             }
//         }
//     ).catch(err => {
//         message.error("获取班次失败", 3);
//     });
// };
//
// /**
//  * store work shifts
//  */
// export const storeWorkShifts = (workShifts) => {
//     return {
//         type: MESSAGE_MANAGEMENT_STORE_WORK_SHIFTS,
//         data: workShifts
//     }
// };
//
// /**
//  * get all preparation users
//  */
// export const getPreparationUsers = () => (dispatch) => {
//     axios({
//         method: "POST",
//         url: "/user-service/workUsers",
//         contentType: "application/json",
//         withCredentials: true,
//         data: {
//             enterprise: "",
//             department: "8b2403c0405e11ebbe3300ff6052c1b5",//检验计量中心
//             workGroup: "8a466ca0784598480178483683b70013",//取制样计量组
//             workShift: ""
//         },
//     }).then(
//         response => {
//             if (response.status === 200) {
//                 if (response.data) {
//                     dispatch(storePreparationUsers(response.data));
//                 } else {
//                     message.warning("未获取到制样人", 3);
//                 }
//             }
//         }
//     ).catch(err => {
//         message.error("获取制样人失败", 3);
//     });
// };
//
// /**
//  * store all preparation users
//  */
// export const storePreparationUsers = (preparationUsers) => {
//     return {
//         type: MESSAGE_MANAGEMENT_STORE_PREPARATION_USERS,
//         data: preparationUsers
//     }
// };

// /**
//  * change message type names
//  */
// export const changeTitleNames = (data) => (dispatch) => {
//     axios({
//         method: "GET",
//         url: `/api-message/titleNames/${data}`,
//         contentType: "application/json",
//         withCredentials: true,
//         data: [],
//     }).then(
//         response => {
//             if (response.status === 200) {
//                 dispatch(storeTitleNames(response.data));
//             }
//         }
//     ).catch(err => {
//         message.error("样品名称缓存读取失败", 3);
//     });
// };
//
// /**
//  * store all sample names
//  */
// export const storeTitleNames = (titleNames) => {
//     return {
//         type: MESSAGE_MANAGEMENT_STORE_SAMPLE_NAMES,
//         data: titleNames
//     }
// };
//
// /**
//  * delete sample name
//  */
// export const deleteTitleName = (data) => (dispatch) => {
//     axios({
//         method: "DELETE",
//         url: `/sample/titleName/${data.id}`,
//         contentType: "application/json",
//         withCredentials: true,
//     }).then(
//         response => {
//             if (response.status === 200) {
//                 message.success("清理样品名称成功", 1);
//                 dispatch(cleanTitleName(data.id));
//             }
//         }
//     ).catch(err => {
//         message.error("删除样品名称失败", 3);
//     });
// };
//
// /**
//  * clean sample name
//  */
// export const cleanTitleName = (id) => {
//     return {
//         type: MESSAGE_MANAGEMENT_CLEAN_SAMPLE_NAME,
//         data: id
//     }
// };
//
// /**
//  * change sample elements by sample type
//  */
// export const changeSampleElement = (sampleElements) => {
//     return {
//         type: MESSAGE_MANAGEMENT_CHANGE_SAMPLE_ELEMENTS,
//         data: sampleElements
//     }
// };

/**
 * add message
 */
export const addMessage = () => {
  return {
    type: MESSAGE_MANAGEMENT_ADD_MESSAGE
  }
};

/**
 * edit message
 */
export const editMessage = (message) => {
  return {
    type: MESSAGE_MANAGEMENT_EDIT_MESSAGE,
    data: message
  }
};

/**
 * view message
 */
export const viewMessage = (message) => {
  return {
    type: MESSAGE_MANAGEMENT_VIEW_MESSAGE,
    data: message
  }
};

/**
 * submit message
 */
export const submitMessage = (data) => (dispatch) => {
  const content = "发送";
  message.loading({content: `${content}中……`, key: "submit"});
  axios({
    method: "POST",
    url: "/api-message/message/sent",
    contentType: "application/json",
    withCredentials: true,
    data: data,
  }).then(
    response => {
      if (response.status === 200) {
        message.success({content: `${content}成功`, key: "submit", duration: 1});
        // if (data.newTitleName) {
        //     dispatch(submitTitleName(data.newTitleName));
        // }
        // data.reload();
        dispatch(updateData({
          name: data.visible,
          value: false
        }));
      } else {
        message.error({content: `${content}失败！`, key: "submit", duration: 3});
        dispatch(toggleButtonLoading(false));
      }
    }
  ).catch(err => {
    console.log(err);
    message.error({content: `${content}失败！`, key: "submit", duration: 3});
    dispatch(toggleButtonLoading(false));
  });
};

/**
 * submit title name
 */
export const submitTitleName = (data) => () => {
  axios({
    method: "POST",
    url: "/api-message/message/titleName",
    contentType: "application/json",
    withCredentials: true,
    data: data,
  }).then(
    response => {
      if (response.status === 200) {
        console.info("新增消息标题成功！");
      }
    }
  ).catch(err => {
    console.warn("新增消息标题失败！");
  });
};

// /**
//  * update message
//  */
// export const updateMessage = (data) => (dispatch) => {
//     const content = data.state === "02" ? "提交申请" : "撤回";
//     message.loading({content: `${content}中……`, key: "update"});
//     axios({
//         method: "PATCH",
//         url: `/sample/message/state/${data.id}`,
//         contentType: "application/json",
//         withCredentials: true,
//         data: data.state,
//     }).then(
//         response => {
//             if (response.status === 200) {
//                 message.success({content: `${content}成功`, key: "update", duration: 1});
//                 // dispatch(queryMessage(data.queryForm));
//                 data.reload();
//             } else {
//                 message.error({content: `${content}失败！`, key: "update", duration: 3});
//             }
//         }
//     ).catch(err => {
//         message.error({content: `${content}失败:${err}`, key: "update", duration: 3});
//     });
// };

/**
 * delete message
 */
export const deleteMessage = (data) => (dispatch) => {
  message.loading({content: "删除中……", key: "delete"});
  axios({
    method: "DELETE",
    url: `/api-message/message/${data.id}`,
    contentType: "application/json",
    withCredentials: true,
  }).then(
    response => {
      if (response.status === 200) {
        message.success({content: "删除成功！", key: "delete", duration: 1});
        // dispatch(queryMessage(data.queryForm));
        data.reload();
      } else {
        message.error({content: "删除失败！", key: "delete", duration: 3});
      }
    }
  ).catch(err => {
    message.error({content: "删除失败！", key: "delete", duration: 3});
  });
};
